<template>
	<div :style="viewStyles">
		<div class="row justify-content-center">
			<div class="col-12 mb-4" :style="'padding-bottom: '+pb+'px'">
				<div ref="fixedContent" class="row justify-content-center fixed-wrapper">
					<div class="col-11 pt-3">
						<barcode-scanner @change="addToList" @resize="updateStyle"/>
						<hr style="margin-bottom: 0;">
					</div>
				</div>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-11">

				{{ $t('Flaschen bei') }} <b v-if="customer">{{ customer.name }}</b>
			</div>
		</div>

		<template v-for="(bottleGroup, due) in bottlesByDueDate">

			<div class="row justify-content-center">
				<div class="col-11">
					<p class="mt-4">{{ $t('Fällig am:') }} {{ new Date(due).toLocaleDateString() }}</p>
				</div>
			</div>
			<template v-for="bottle in bottleGroup">
				<scanner-list-item :key="bottle.serial"
				                   v-if="bottles[bottle.serial] || showDeleted"
				                   :bottle-no="bottle.serial"
				                   :highlights="false"
				>
					<template v-slot:default="{bottleNo}">
						<button v-if="bottles[bottle.serial]"
						        class="btn btn-sm"
						        @click="toggleBottle(bottleNo)"
						>
							<i class="fa fa-check"></i>
						</button>
					</template>

				</scanner-list-item>
			</template>
		</template>

		<bottom-navigation @new-height="setBottomPadding">
			<template v-slot:left>
				<button class="btn btn-light btn-block" @click="$router.back()">{{ $t('Abbrechen') }}</button>
			</template>
			<template v-slot:right>
				<button class="btn btn-primary btn-block" @click="finalizeCollection">
					{{ $t('Fertig') }}
				</button>
			</template>
		</bottom-navigation>
	</div>
</template>

<script>
import Vue from 'vue'
import ScannerListItem from "../../components/ScannerListItem";
import BottomNavigation from "../../components/BottomNavigation";
import BarcodeScanner from "../../components/BarcodeScanner";
import allViews from "../../mixins/allViews";
import {mapActions, mapGetters, mapState} from "vuex";
import dayjs from "dayjs";

export default {
	name: "Scanner",
	components: {BarcodeScanner, ScannerListItem, BottomNavigation},
	mixins: [allViews],
	data() {
		return {
			bottles: {},
			details: [],
			showDeleted: true,
			pb: 0,
		}
	},
	computed: {
		...mapState({
			customer: state => state.Api.Customers.current,
			allBottles: state => state.Api.Bottles.all,
			scid: state => state.selectedCustomerId
		}),
		...mapGetters({
			getLatestActionId: "getLatestActionId",
			getSelectedCustomer: "getSelectedCustomer",
		}),
		activeBottles() {
			return Object.keys(this.bottles).filter((el) => this.bottles[el])
		},
		bottlesByDueDate() {
			let grouped = {};
			this.allBottles
				.filter(el => {
					if (!Array.isArray(el.bottle_actions) || el.bottle_actions.length === 0) {
						return false
					}

					let action = el.bottle_actions[0];

					return action.action === 'at_customer' && action.customer_id === this.scid

				})
				.sort((a, b) => {
					if (a.due < b.due) {
						return -1;
					}
					if (a.due > b.due) {
						return 1;
					}
					return 0;
				})
				.forEach(el => {
					if (!el.due) {
						console.log('ohne due =>', el)
					}

					let dueDate = dayjs(el.due).format(this.$config.API_DATE_FORMAT);
					if (!Array.isArray(grouped[dueDate])) {
						grouped[dueDate] = [el]
					} else {
						grouped[dueDate].push(el)
					}
				});
			return grouped
		}
	},
	mounted() {
		this.refreshBottles()
			.catch(this.apiErrorHandler);

		if (this.scid) {
			this.fetchCustomerDetails({id: this.scid})
				.then(result => {
					if (Array.isArray(result.bottles)) {
						this.details = result.bottles;
						let bottles = {};
						result.bottles.forEach((el) => bottles[el.serial] = false);
						this.bottles = bottles;
					}
				})
				.catch(this.apiErrorHandler)
		}
	},
	methods: {
		...mapActions({
			moveBottlesFromCustomer: "Api/Bottles/from_customer",
			fetchCustomerDetails: "Api/Customers/get",
			refreshBottles: "Api/Bottles/all"
		}),
		updateStyle() {
			this.pb = this.$refs.fixedContent.clientHeight
		},
		addToList(serial) {
			if (!this.bottles[serial]) {
				console.log('add Bottle to list:', serial);
				Vue.set(this.bottles, serial, true);
			}
		},
		toggleBottle(serial) {
			console.log(serial)
			Vue.set(this.bottles, serial, !this.bottles[serial]);
		},
		async finalizeCollection() {
			let feedbackMsg1Bottle = this.$t('1 Flasche erfolgreich ins Auto geladen');
			let feedbackMsgBottles = this.$t('Flaschen erfolgreich ins Auto geladen');
			let bottleCollection = this.activeBottles.map(el => {
				return {
					serial: el,
					driver_id: 'self',
					parent_id: this.getLatestActionId(el)
				}
			})
			try {
				let movedBottles = await this.moveBottlesFromCustomer({
					bottles: bottleCollection
				});

				if (movedBottles.length === 1) {
					this.cdvAlert(feedbackMsg1Bottle);
				} else {
					this.cdvAlert([movedBottles.length, feedbackMsgBottles].join(' '));
				}

				this.$router.push('/home').catch(() => null);

			} catch (e) {
				this.apiErrorHandler(e);
			}

		}
	}
}
</script>
